import React from 'react';
import { motion } from 'framer-motion';

// "Estrelinha" — a friendly star mascot who is the child's math buddy.
// mood: 'idle' | 'happy' | 'cheer' | 'sad' | 'talk'
const MOOD_CONFIG = {
  cheer: { color: '#FCD34D', bounce: { y: [0, -18, 0], rotate: [0, -6, 6, 0] }, dur: 0.7 },
  happy: { color: '#FCD34D', bounce: { y: [0, -8, 0] }, dur: 2.4 },
  sad: { color: '#93C5FD', bounce: { rotate: [0, -3, 3, 0], y: [0, 2, 0] }, dur: 2.4 },
  talk: { color: '#FCD34D', bounce: { y: [0, -6, 0] }, dur: 0.5 },
  idle: { color: '#FCD34D', bounce: { y: [0, -6, 0] }, dur: 2.4 },
};

export function Mascot({ mood = 'idle', size = 140, className = '' }) {
  const cfg = MOOD_CONFIG[mood] || MOOD_CONFIG.idle;
  const bodyColor = cfg.color;
  const bounce = cfg.bounce;
  const dur = cfg.dur;
  const isHappyFace = mood === 'cheer' || mood === 'happy';

  return (
    <motion.div
      className={className}
      animate={bounce}
      transition={{ duration: dur, repeat: Infinity, ease: 'easeInOut' }}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <svg viewBox="0 0 120 120" width={size} height={size}>
        <defs>
          <radialGradient id="starGrad" cx="50%" cy="40%" r="65%">
            <stop offset="0%" stopColor="#FEF08A" />
            <stop offset="100%" stopColor={bodyColor} />
          </radialGradient>
        </defs>
        {/* star body */}
        <path
          d="M60 6 L74 44 L114 46 L82 70 L94 110 L60 86 L26 110 L38 70 L6 46 L46 44 Z"
          fill="url(#starGrad)"
          stroke="#F59E0B"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        {/* cheeks */}
        <circle cx="44" cy="66" r="6" fill="#FB7185" opacity="0.6" />
        <circle cx="76" cy="66" r="6" fill="#FB7185" opacity="0.6" />
        {/* eyes */}
        {mood === 'sad' ? (
          <>
            <path d="M40 54 q6 -6 12 0" stroke="#334155" strokeWidth="4" fill="none" strokeLinecap="round" />
            <path d="M68 54 q6 -6 12 0" stroke="#334155" strokeWidth="4" fill="none" strokeLinecap="round" />
            <circle cx="46" cy="60" r="3" fill="#334155" />
            <circle cx="74" cy="60" r="3" fill="#334155" />
            {/* tear */}
            <motion.circle
              cx="50"
              cy="66"
              r="3"
              fill="#38BDF8"
              animate={{ cy: [66, 74], opacity: [1, 0] }}
              transition={{ duration: 1.4, repeat: Infinity }}
            />
          </>
        ) : (
          <>
            <circle cx="46" cy="56" r="6" fill="#334155" />
            <circle cx="74" cy="56" r="6" fill="#334155" />
            <circle cx="48" cy="54" r="2" fill="#fff" />
            <circle cx="76" cy="54" r="2" fill="#fff" />
          </>
        )}
        {/* mouth */}
        {mood === 'sad' && (
          <path d="M50 78 q10 -8 20 0" stroke="#334155" strokeWidth="4" fill="none" strokeLinecap="round" />
        )}
        {isHappyFace && (
          <path d="M48 74 q12 16 24 0 q-12 6 -24 0Z" fill="#EF4444" stroke="#B91C1C" strokeWidth="2" />
        )}
        {mood !== 'sad' && !isHappyFace && (
          <path d="M50 74 q10 10 20 0" stroke="#334155" strokeWidth="4" fill="none" strokeLinecap="round" />
        )}
      </svg>
    </motion.div>
  );
}
